export default {
  /**
   * Calculates column count for md grid attribute depending on parameter
   * maxCols, which is the maximum columns to be displayed, and the displayItems. If later is less 3
   * the columns to be displayed is 9.
   * @param {*} maxCols
   * @param {*} displayItems
   */
  colsMd(maxCols, displayItems) {
    if (displayItems.length < 3) {
      return '9';
    }
    switch (maxCols) {
      case 3:
        return '4';
      case 2:
        return '6';
      default:
        return '12';
    }
  },
  /**
   * Calculates column count for sm grid attribute depending on parameter
   * maxCols, which is the maximum columns to be displayed, and the displayItems. If later is less 3
   * the columns to be displayed is 9.
   * @param {*} maxCols
   * @param {*} displayItems
   */
  colsSm(maxCols, displayItems) {
    if (displayItems.length < 3) {
      return '9';
    }
    switch (maxCols) {
      case 3:
        return '6';
      case 2:
        return '6';
      default:
        return '12';
    }
  },
};
